<mat-form-field class="root">
  <mat-label>Sort by</mat-label>
  <mat-select (valueChange)="handleSelect($event)" [value]="value">
    @for (option of OPTIONS; track option) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>
</mat-form-field>
